import DATATABLE_TRANSLATIONS from "./datatable_translations";

export default class ReportsDataTable {
  constructor() {
    $(document).ready(function() {
      showReportsTable();
    });

    $(document).on("turbo:render", function() {
      showReportsTable();
    });

    function showReportsTable() {
      $('#reports-datatable').dataTable({
        "order": [],
        "columnDefs": [ {
          "targets"  : 'no-sort',
          "orderable": false,
        }],
        "language": DATATABLE_TRANSLATIONS,
        "processing": true,
        "serverSide": true,
        "ajax": {
          "url": $('#reports-datatable').data('source')
        },
        "pagingType": "full_numbers",
        "columns": [
          {"data": "name"},
          {"data": "slug"},
          {"data": "actions"}
        ]
        // pagingType is optional, if you want full pagination controls.
        // Check dataTables documentation to learn more about
        // available options.
      });
    }
  }
}
